import PicturesCarousel from '../PicCarousel/PicturesCarousel';
import './Partners.less';
import {partnersInfo} from './PartnersData';

const truncateDescription = (text: string, maxLength: number) => {
	if (text.length > maxLength) {
		return text.substring(0, maxLength) + '...';
	}
	return text;
};

const Partners: React.FC = () => {
	return (
		<>
			<div className="partners">
				<div className="partners__container">
					<div className="partners__content">
						<div className="partners__top-title">
							<div className="partners__main-title">
								<p>our partners</p>
							</div>
							<div className="partners__main-subtitle">
								<div className="partners__subtitle-first">
									<p>Unlimited options give you the ultimate flexibility</p>
								</div>
								<div className="partners__subtitle-second">
									<p>Join our highly motivated and like-minded</p>
								</div>
							</div>
						</div>
						<div className="pic-carousel-block">
							<PicturesCarousel />
							<PicturesCarousel direction="rightToLeft" />
						</div>
						<div className="partners__cards">
							{partnersInfo.map((partner, index) => {
								return (
									<div
										key={index}
										className="partners-card__main"
										onClick={() => window.open(partner.link, '_blank')}>
										<div className="partners-info-card__container">
											<div className="partners-info-card__content">
												<div className="partners-info-card__row info-card__image">
													<img
														src={partner.logo}
														alt="img"
														className="partners-info-card-logo"
													/>
												</div>
												<div className="partners-info-card__row info-card__text">
													<p>{partner.name}</p>
												</div>
											</div>
										</div>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Partners;
